import { render, staticRenderFns } from "./FilesArea.vue?vue&type=template&id=4cf7e8c4"
import script from "./FilesArea.vue?vue&type=script&lang=js"
export * from "./FilesArea.vue?vue&type=script&lang=js"
import style0 from "./FilesArea.vue?vue&type=style&index=0&id=4cf7e8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports